import { TNullable } from '@/types';
import { useEffect, useRef } from 'react';

/**
 * Custom hook that sets up an interval to call a given callback function at specified intervals.
 * The callback function is always up-to-date with the latest reference, and the interval is properly cleaned up when the component unmounts or when the delay changes.
 * @param callback - The function to be called at each interval.
 * @param delay - The time in milliseconds between each call of the callback function. If null, the interval will not be set.
 */
export const useInterval = (callback: () => void, delay: TNullable<number>) => {
  const savedCallback = useRef<() => void>(undefined);

  savedCallback.current = callback;

  // Set up interval once
  useEffect(() => {
    if (delay === null) return;

    const id = setInterval(() => {
      savedCallback.current?.();
    }, delay);

    return () => clearInterval(id);
  }, [delay]);
};
